import {
    GETVIEWCONGIGURATIONLISTADMIN_SUCCESS,
    GETVIEWCONGIGURATIONLISTADMIN_FAILED,
    RESET_GETVIEWCONGIGURATIONLISTADMIN,
    LOADING_GETVIEWCONGIGURATIONLISTADMIN,
    NETWORK_GETVIEWCONGIGURATIONLISTADMIN,
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETVIEWCONGIGURATIONLISTADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETVIEWCONGIGURATIONLISTADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETVIEWCONGIGURATIONLISTADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_GETVIEWCONGIGURATIONLISTADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETVIEWCONGIGURATIONLISTADMIN:
            return (state = initialState);
        default:
            return state;
    }
};